import { Text } from "components/materials";

export function HeaderTextCell({ children, ...cellProps }) {
  return (
    <th {...cellProps}>
      <Text size={300}>{children}</Text>
    </th>
  );
}
